import styled from 'styled-components/macro';

export const PlayerWrapperStyled = styled.div.attrs({
  className: 'PlayerWrapperStyled',
})`
  width: 100%;
`;
